import {
LOGIN_SUCCESS,
LOGIN_FAILURE,
SET_USER_DETAILS,
LOGOUT
} from './action';
 const initialState = {
     loginSuccess: {},
     loginFailure:{},
     userDetails: {}
 }

 const loginReducer = (state=initialState, action) => {
     switch(action.type) {
        case LOGIN_SUCCESS:
        return  state = {
            ...state,
            loginSuccess: action.data
        }
        case LOGIN_FAILURE:
        return  state = {
            ...state,
            loginFailure: action.data
        }
        case SET_USER_DETAILS: 
        return state = {
            ...state,
            userDetails: action.data
        }
        case LOGOUT:
        return state = {
          ...initialState
        }
        default: return state
     }
 }
 export default loginReducer;